import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Breadcrumbs, Typography } from "@mui/material";

interface BreadcrumbItem {
    label: string;
    path?: string;
}

interface BreadcrumbProps {
    items: BreadcrumbItem[];
    name:ReactNode;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, name }) => {
    return (
        <div style={{marginTop:-5}}>
            <Typography variant="h5" fontWeight="bold">{name}</Typography>
            <Breadcrumbs aria-label="breadcrumb" separator="›">
                {items.map((item, index) => (
                    <div key={index}>
                        {item.path ? (
                            <Link to={`/${item.path}`} style={{ textDecoration: "none", color: "#3660f9" }}>
                                <Typography variant="body2" color="inherit">
                                    {item.label}
                                </Typography>
                            </Link>
                        ) : (
                            <Typography variant="body2" color="textSecondary">
                                {item.label}
                            </Typography>
                        )}
                    </div>
                ))}
            </Breadcrumbs>
        </div>
    );
};

export default Breadcrumb;
